import { StudentStoreState, AccomplishmentCertificate } from './state';

import * as   types from './types';

export default function notification(state = StudentStoreState, action: any) {

  switch (action.type) {
    case types.STUDENT_INFO:
      return {
        ...state,
        ...action.payload
      };
    case types.STUDENT_INFO_ERROR:
      return {
        ...state,
        ...action.payload
      };
    case types.MY_ACCOMPLISHMENT_DETAIL:
      return {
        ...state,
        myAccomplishment: {
          ...state.myAccomplishment,
          current: action.payload
        }
      }
    case types.MY_ACCOMPLISHMENT:
      const accomplishmentList = [...action.payload];
      let course: AccomplishmentCertificate[] = [];
      let program: AccomplishmentCertificate[] = [];
      accomplishmentList.forEach((myAccomplishment: AccomplishmentCertificate) => {
        if (myAccomplishment.certificateOf === 'COURSE') {
          course = [...course, myAccomplishment];
        } else if (myAccomplishment.certificateOf === 'PROGRAM') {
          program = [...program, myAccomplishment];
        }
      });
      return {
        ...state,
        myAccomplishment: {
          course,
          program
        }
      };

    default:
      return state;
  }
}
